import { ArrowDown } from 'lucide-react'

interface ScrollToBottomProps {
  visible: boolean
  onClick: () => void
}

export function ScrollToBottom({ visible, onClick }: ScrollToBottomProps) {
  if (!visible) return null

  return (
    <button
      className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 rounded-base border-2 border-nb-border bg-secondary-bg p-2 text-foreground nb-shadow-sm nb-hover-press transition-all"
      onClick={onClick}
    >
      <ArrowDown className="h-4 w-4" />
    </button>
  )
}
